export default __webpack_public_path__ + "static/notosans-bold-webfont-a98fde6adc9e37882589611b00fc50ea.ttf";